import { MobileBuildInfo } from '../models'
import { useMobileMode } from './useMobileMode'

declare const BuildInfo: MobileBuildInfo | null | undefined

export function useMobileBuildInfo() {
  const isMobileMode = useMobileMode()
  return isMobileMode ? BuildInfo : undefined
}
